import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { update_password, deleteAccount, deactivateAccount } from '../../Apis';


export const Updatepwd = createAsyncThunk('chnage passwordd', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await update_password(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const DeleteAc = createAsyncThunk('dele account', async (token, { rejectWithValue }) => {
    try {
        const response = await deleteAccount(token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const DeactivateAc = createAsyncThunk('deactivate account', async (token, { rejectWithValue }) => {
    try {
        const response = await deactivateAccount(token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const settingSlice = createSlice({
    name: 'settings',
    initialState: {
        error: null,
        success: false,

    },
    reducers: {
        clearSettingStatus: state => {
            state.success = false;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(Updatepwd.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Updatepwd.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(Updatepwd.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearSettingStatus } = settingSlice.actions;
export default settingSlice.reducer;



